import React, { Component } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import Axios from "axios";
import {estados} from "../../util/estados";
import tipos from "./tipos";

import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";
import { asyncSelectCustomStyles } from "../../util/styles";
import { InputSwitch } from "primereact/inputswitch";

import {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from "react-places-autocomplete";

import IntlCurrencyInput from "react-intl-currency-input";

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

class FormFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: estados,
            cidades: [],
            address: "",
            types: [],
        };
    }

    dormitorios = [0, 1, 2, 3, 4];
    vagas = [0, 1, 2, 3, 4];


    loadTypes = async () => {
        try {
            let response = await axios.get(route("polos-geradores-tipos"));

            if (response.status == 200) {
                let types = response.data.types;

                let options = [];

                types.forEach((type) => {
                    options.push({ value: type, label: type });
                });

                this.setState({ types: options });
            }
        } catch (e) {
            console.log(e);
        } finally {
        }
    };

    componentDidMount = async () => {
        this.props.getProjects();
        await this.loadTypes();
    };

    searchCidade = async (inputQuery) => {
        let state = this.props.estadosSelecionados != null
            ? this.props.estadosSelecionados
            : null;

        if (inputQuery.length >= 2) {
            const response = await Axios.get(
                "/cidades/json-options-by-state/" + state + "/" + inputQuery
            );
            return response.data;
        }
    }

    handleChange = (address) => {
        this.setState({ ...this.state, address: address });
    };

    handleSelect = (address) => {

        this.setState({ ...this.state, address: address });

        geocodeByAddress(address)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => {

                window.googleMap.panTo(latLng);

                this.props.handleCidadeChanged(latLng.lat, latLng.lng, address);
            })
            .catch((error) => console.error("Error", error));
    };

    handleValorMaximoChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMaximoChanged(value);
    };

    handleValorMinimoChange = async (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMinimoChanged(value);
    };

    handleValorMetroMaximoChange = async (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMetroMaximoChanged(value);
    };

    handleValorMetroMinimoChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMetroMinimoChanged(value);
    };


    handleValorParcelaMinimaChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorParcelaMinimaChanged(value);
    };

    render() {
        return (
            <div
                style={{
                    overflowX: "hidden",
                    height: "90vh",
                }}
            >
                <div className="card filtro-mapa">
                    <div className="card-body">
                        <div className="form-group">
                            <label>Carregar Projeto</label>
                            <Dropdown
                                options={this.props.projeto_name}
                                onChange={this.props.handleProjetoChanged}
                                style={{ width: "100%", borderRadius: '0px' }}
                                components={reactSelectIcons}
                                placeholder="Selecione"
                                display={"chip"}
                            />
                        </div>
                        <div className="form-group">
                            <label>Tipo Negócio</label>

                            <Dropdown
                                options={[
                                    { value: "Venda", label: "Revenda", },
                                    { value: "Aluguel", label: "Locação", },
                                ]}
                                onChange={this.props.handleTipoNegocioChanged}
                                style={{ width: "100%", borderRadius: '0px' }}
                                components={reactSelectIcons}
                                placeholder="Selecione"
                                display={"chip"}
                                value={this.props.tipo_negocio}
                                isDisabled={this.props.tipo_negocio_readonly}
                            />
                        </div>
                        <div className="form-group">
                            <label>Tipo Empreendimento</label>

                            <MultiSelect
                                resetFilterOnHide
                                value={this.props.tipo}
                                options={tipos.select_options}
                                onChange={this.props.handleTipoEmpreendimentoChanged}
                                style={{ width: "100%", borderRadius: '0px' }}
                                placeholder="Selecione"
                                filter
                                display={"chip"}
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                emptyFilterMessage={"Nenhum resultado encontrado"}
                            />
                        </div>

                        <div className="form-group">
                            <label>Estado</label>

                            <Dropdown
                                options={this.state.estados}
                                onChange={this.props.handleEstadosChanged}
                                style={{ width: "100%", borderRadius: '0px' }}
                                components={reactSelectIcons}
                                placeholder="Selecione"
                                display={"chip"}
                                value={this.props.estadosSelecionados}
                            />
                        </div>

                        <div className="form-group">
                            <label>Cidade</label>
                            <AsyncSelect
                                styles={asyncSelectCustomStyles}
                                placeholder="Selecione"
                                isMulti={false}
                                value={this.props.cidade[0] || null}
                                loadOptions={this.searchCidade}
                                onChange={this.props.handleCidadeChanged}

                                inputValue={this.props.inputCidade}
                                onInputChange={this.props.handleInputCidadeChange}
                                components={reactSelectIcons}
                                loadingMessage={() => 'Carregando...'}
                                noOptionsMessage={() => "Digite para buscar..."}


                            />
                        </div>

                        <div className="form-group">
                            <label>Bairros</label>

                            <MultiSelect
                                resetFilterOnHide
                                options={this.props.bairrosOptions}
                                value={this.props.bairros}
                                style={{ width: "100%", borderRadius: '0px' }}

                                placeholder="Selecione"
                                display={"chip"}
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                onChange={this.props.handleBairrosChanged}
                                filter
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>

                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Área Mínima</label>
                                <input
                                    type="number"
                                    name="area_minima"
                                    value={this.props.area_minima}
                                    onChange={this.props.handleAreaMinimaChanged}
                                    style={{ padding: "3px" }}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Área Máxima</label>
                                <input
                                    type="number"
                                    name="area_maxima"
                                    value={this.props.area_maxima}
                                    onChange={this.props.handleAreaMaximaChanged}
                                    style={{ padding: "3px" }}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Preço Mínimo</label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    value={this.props.valor_maior_que}
                                    onChange={this.handleValorMinimoChange}
                                    style={{ padding: "3px" }}
                                    className={this.props.showAlertCity ? "form-control is-invalid" : "form-control "}
                                />
                                <span className="invalid-feedback" role="alert">
                                    <strong>Campo requerido</strong>
                                </span>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Preço Máximo</label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={this.handleValorMaximoChange}
                                    style={{ padding: "3px" }}
                                    className={this.props.showAlertCity ? "form-control is-invalid" : "form-control "}
                                    value={this.props.valor_menor_que}
                                />
                                <span className="invalid-feedback" role="alert">
                                    <strong>Campo requerido</strong>
                                </span>
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>
                                    Preço R$/m<sup>2</sup> Mínimo
                                </label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={this.handleValorMetroMinimoChange}
                                    style={{ padding: "3px" }}
                                    value={this.props.valor_metro_maior_que}
                                    className="valor form-control"
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>
                                    Preço R$/m<sup>2</sup> Máximo
                                </label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={this.handleValorMetroMaximoChange}
                                    style={{ padding: "3px" }}
                                    value={this.props.valor_metro_menor_que}
                                    className="valor form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group margin-bottom-0">
                            <label>Quartos</label>
                            <br />

                            {this.dormitorios.map((tipo) => {
                                return (
                                    <div className="form-check checkbox-inline pr-1">
                                        <div className="d-flex align-items-center">
                                            <InputSwitch
                                                id={"check_quarto_" + tipo}
                                                checked={this.props.quartos.includes(tipo)}
                                                onChange={(e) => this.props.handleQuartosChanged(tipo)}
                                            />
                                            <label htmlFor={"check_quarto_" + tipo} className="pl-1 mb-0 ms-2">
                                                {tipo}
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="form-group">
                            <label>Vagas</label>
                            <br />
                            {this.vagas.map((tipo) => {
                                return (
                                    <div className="form-check checkbox-inline pr-1">
                                        <div className="d-flex align-items-center">
                                            <InputSwitch
                                                id={"check_vagas_" + tipo}
                                                checked={this.props.vagas.includes(tipo)}
                                                onChange={(e) => this.props.handleVagasChanged(tipo)}
                                            />
                                            <label htmlFor={"check_vagas_" + tipo} className="pl-1 mb-0 ms-2">
                                                {tipo}
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="card-footer btn-filtro-mobile"
                        style={{
                            position: "sticky",
                            bottom: "27px",
                            backgroundColor: "#FFF",
                            padding: "5px 10px",
                            boxShadow: "0, 0, 3px, rgba(0,0,0, .2",
                        }}
                    >
                        <div className="row" id="container-btn-filtros">
                            <div className="col-6">
                                <button
                                    className="btn btn-block background-brain"
                                    onClick={this.props.handleSubmit}
                                >
                                    {this.props.overlays.length > 0
                                        ? 'ATUALIZAR'
                                        : 'BUSCAR'}
                                </button>
                            </div>
                            <div className="col-6">
                                <button
                                    className="btn btn-block btn-default default-gray"
                                    onClick={this.props.cleanState}
                                >
                                    LIMPAR
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormFilters;
